<template>
    <Card title="外部网站" url="/knowledge/lib/out" name="更多">
        <a-row>
            <a-col :span="6" v-for="item in list" :key="item.id">
                <a class="item" target="_blank" :href="getLink(item)">
                    <img :src="item.imagePath" alt="系统图标" />
                    <div>{{ item.title }}</div>
                </a>
            </a-col>
        </a-row>
    </Card>
</template>
  
<script>
import Card from "./card.vue";
export default {
    components: {
        Card,
    },
    data() {
        return {
            list: [
                // {
                //     imagePath: require('../assets/cosys.png'),
                //     title: "协同设计(新)",
                //     path: "https://portal.njszy.com/cosys/#/dashboard",
                // },
                {
                    imagePath: require('../assets/22.png'),
                    title: "协同设计(旧)",
                    path: "http://218.94.135.30:8025/portal/",
                },
                {
                    // icon: require('../assets/11.jpeg'),
                    imagePath: require('../assets/33.png'),
                    title: "三纲出图",
                    path: "http://10.23.23.118",
                },
                {
                    imagePath: require('../assets/bk-water.jpeg'),
                    title: "集团门户",
                    path: 'https://portal.bewg.net.cn',
                },


                {
                    imagePath: require('../assets/email.png'),
                    title: "企业邮箱",
                    path: 'https://qiye.aliyun.com/alimail/',
                },

                {
                    imagePath: require('../assets/partyManage.png'),
                    title: "智慧党建",
                    path: 'https://portal.njszy.com/party',
                },
                {
                    imagePath: require('../assets/bidinfo.svg'),
                    title: "招标信息",
                    path: 'https://bidinfo.njszy.com/',
                    sso: true,
                },
                {
                    imagePath: require('../assets/oa.png'),
                    title: "集团OA",
                    path: 'https://oa.bewg.net.cn/seeyon/main.do?method=main',
                },
                {
                    imagePath: require('../assets/bill.png'),
                    title: "网上报销",
                    path: 'https://bewgfinance.bewg.net.cn/ierp/?formId=pc_main_console&code=87fcSe&state=/ierp/',
                }
            ],
        };
    },

    methods: {
        // 拼接跳转地址；标记 sso 的站点与本系统同账号，携带当前登录 token 免登陆
        getLink(item) {
            if (!item.sso) {
                return item.path;
            }
            const token = window.localStorage.getItem('token') || '';
            return item.path + '?sso=' + encodeURIComponent(token);
        },
    },

};
</script>
  
<style lang="less" scoped>
.card {
    background-color: #fff;
    padding-bottom: 0;
}

.item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-radius: 4px;
    color: #333;
    font-size: 12px;
    cursor: pointer;

    &:hover {
        background-color: #f9f9f9;
    }

    img {
        height: 38px;
        width: 38px;
        object-fit: cover;
        margin-bottom: 6px;
        border-radius: 6px;
    }
}
</style>